/**
 * Copyright (c) 2023-present,
 * Eunoia Digital, S.L. All rights reserved.
 */

import { AxiosError, AxiosResponse } from 'axios';
import configuration from 'config';
import MatcherInforme from 'types/models/MatcherInforme';
import apiService from './ApiService';

type InformeEstado = {
  datos: {
    estado: 'ENEJECUCION';
  };
};
export class MatcherInformeService {
  private readonly http = apiService;

  private apiUrl = configuration.apiUrl;

  public async getInforme(id: number): Promise<MatcherInforme> {
    const url = `${this.apiUrl}/matcher/configuracion-matcher/${id}/informe/`;

    const response: AxiosResponse = await this.http.get(url);
    const informe = new MatcherInforme().deserialize(response.data.datos);
    return informe;
  }

  public async ejecutarInforme(id: number): Promise<any> {
    const url = `${this.apiUrl}/matcher/configuracion-matcher/${id}/ejecutar/`;
    let responsePromise;
    try {
      const response: AxiosResponse = await this.http.post(url);
      responsePromise = response.status;
    } catch (error: unknown) {
      if ((error as AxiosError)?.response?.data && (error as AxiosError).response?.status === 400) {
        responsePromise = {
          codigo: (error as AxiosError).response?.data.errores[0].codigo,
          mensaje: (error as AxiosError).response?.data.errores[0].mensaje,
        };
      }
    }
    return responsePromise;
  }

  // Devuelve un CSV (representado por Blob en JavaScript)
  public async descargarInforme(id: number): Promise<Blob> {
    const url = `${this.apiUrl}/matcher/configuracion-matcher/${id}/informe/descargar/`;
    const response: AxiosResponse<Blob> = await this.http.get(url);

    return response.data;
  }

  // Devuelve un CSV (representado por Blob en JavaScript)
  public async descargarListaDistribucion(id: number): Promise<Blob> {
    const url = `${this.apiUrl}/matcher/configuracion-matcher/${id}/informe/lista-de-distribucion/`;
    const response: AxiosResponse<Blob> = await this.http.get(url);

    return response.data;
  }

  public async estadoInforme(id: number): Promise<string> {
    const url = `${this.apiUrl}/matcher/configuracion-matcher/${id}/informe/estado/`;
    try {
      const response: AxiosResponse<InformeEstado> = await this.http.get(url);
      return response.data.datos.estado;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        return 'NOEJECUTADO';
      }

      console.error('Error:', error);
      return 'error';
    }
  }
}

const MatcherInformeInstance = new MatcherInformeService();
export default MatcherInformeInstance;
